$(document).ready(function($) {
    function toggleStickyHeader() {
        var scrollY = $(window).scrollTop();
        var pageHeight = $(document).height();
        var $header = $('.site-header');

        if (pageHeight < 200 || scrollY < 200) {
            if ($header.hasClass('sticky-header')) {
                $header.removeClass('sticky-header');
            }
        } else {
            if (!$header.hasClass('sticky-header')) {
                $header.addClass('sticky-header');
            }
        }
    }

    $(window).on('scroll resize', function() {
        toggleStickyHeader();
    });

    toggleStickyHeader();
});


$(document).ready(function() {

    $(window).scroll(function () {
        var scrollPercentage = 100 * ($(this).scrollTop() / ($('body').height() - $(window).height()));
    
        if (scrollPercentage >= 3) {
            $('#sidebar').addClass('start-scrolling');
        } else {
            $('#sidebar').removeClass('start-scrolling');
        }
    });
    

    $('#popular-product-slider').slick({
        slidesToShow: 4,
        dots: false,
        infinite: false,
        arrows: true,
        autoplay: false,
        autoplaySpeed: 3000,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    }).on('setPosition', function (event, slick) {
        var maxHeight = 0;
        slick.$slides.each(function () {
            $(this).css('height', 'auto'); 
            maxHeight = Math.max(maxHeight, $(this).outerHeight());
        });
        slick.$slides.css('height', maxHeight + 'px');
    });        
    // faqs js
    $('.faq-question').click(function() {
        const answer = $(this).next('.faq-answer');
        const icon = $(this).find('.faq-toggle-icon img');

        // Close any other open FAQ items
        $('.faq-answer').not(answer).slideUp();
        $('.faq-toggle-icon img').not(icon).removeClass('rotate');

        // Toggle the clicked FAQ item
        answer.slideToggle();
        icon.toggleClass('rotate');
    });
    $(".add-to-cart-btn").on("click", function () {
        const $button = $(this);

        // const $productContainer = $button.closest(".product-card");
        const productId = $button.data("product-id");  // Make sure this is the variant ID
        const quantity = $button.siblings(".quantity-dropdown").find(".quantity-select").val();
    
        if (!productId || !quantity) {
            console.error("Product ID or quantity is missing.");
            return;
        }
    
        $button.prop("disabled", true);
    
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({
                id: productId,
                quantity: parseInt(quantity, 10)
            })
        })
        .then(response => response.json())
        .then(data => {
            if (data.status && data.status === 'error') {
                console.error('Error adding product to cart:', data.message);
                // alert(`Error: ${data.message}`);
            } else {
                console.log('Product added to cart:', data);
                // $productContainer.find(".cart-message").text(`Added ${quantity} item(s) to the cart!`).addClass('active');

                const popupMessage = `Added ${quantity} item to the cart!`;
                $("#popup-message").text(popupMessage);
                $("#cart-popup").addClass("active");
    
                // Fetch updated cart and update the cart count
                fetch('/cart.js')
                    .then(response => response.json())
                    .then(cart => {
                        $('.cart-count').text(cart.item_count || 0);
                    })
                    .catch(error => {
                        console.error('Error fetching cart:', error);
                    });
                // alert(`Added ${quantity} item(s) to cart.`);
            }
        })
        .catch(error => {
            console.error("Error:", error.message);
            // alert(error.message || 'An unexpected error occurred.');
        })
        .finally(() => {
            $button.prop("disabled", false);
        });
    });  
    $(document).on("click", ".close-btn, .popup-overlay", function () {
        $("#cart-popup").removeClass("active");
    }); 
    
    // Product Enquiry Popup js
    $(".make-enquiry-btn").click(function() {
        $(".product-enquiry-popup-section").fadeIn();
    });
    
    $(".close-popup, .product-enquiry-popup-overlay").click(function() {
        $(".product-enquiry-popup-section").fadeOut();
    });
      
});

$(document).ready(function() {
  $('.mobile-search-icon').on('click', function() {
    $('#search-section').toggle();
  });
});


document.addEventListener('DOMContentLoaded', function () {
    var recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewed')) || [];

    // If no recently viewed products, hide the entire section
    if (!recentlyViewed.length) {
      var wrapper = document.getElementById('recently-viewed-wrapper');
      if (wrapper) {
        wrapper.style.display = 'none';
      }
    }
});


// const detailsDrawer = document.querySelector('#Details-menu-drawer-container');

// detailsDrawer.addEventListener('toggle', function () {
//   if (detailsDrawer.open) {
//     document.body.style.overflow = 'hidden';
//   } else {
//     document.body.style.overflow = '';
//   }
// });


// // toogle mobile menu js
// const menuToggle = document.getElementById('menu-toggle');
// const sidebar = document.getElementById('sidebar');
// const closeBtn = document.getElementById('close-btn');
// const viewProductsBtn = document.getElementById('view-products');
// const mainMenu = document.getElementById('main-menu');
// const catMenu = document.getElementById('cat-menu');
// const productsMenu = document.getElementById('products-menu');
// const backToMain = document.getElementById('back-to-main');

// // Open sidebar
// menuToggle.addEventListener('click', () => {
//   sidebar.classList.add('open');
//   closeBtn.classList.add('active');
// });

// // Close sidebar
// closeBtn.addEventListener('click', () => {
//   sidebar.classList.remove('open');
//   closeBtn.classList.remove('active');
// });

// // Show Category Menu (cat-menu) when clicking "View Products"
// viewProductsBtn.addEventListener('click', (e) => {
//   e.preventDefault();
//   mainMenu.style.display = 'none';
//   catMenu.style.display = 'block';
// });

// // Prevent navigation to the third menu (products-menu) when clicking on category items
// // catMenu.addEventListener('click', (e) => {
// //   const target = e.target.closest('.menu-item');
// //   if (target) {
// //     e.preventDefault();
// //     // If required, you can add logic to highlight or process the selected item.
// //     console.log('Clicked:', target.querySelector('span').innerText);
// //   }
// // });

// // Navigate back to Main Menu (main-menu) from cat-menu
// backToMain.addEventListener('click', (e) => {
//   e.preventDefault();
//   mainMenu.style.display = 'block';
//   catMenu.style.display = 'none';
// });







